import { FC } from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { cn } from '@fe-learner-common';

export interface RadioButtonProps {
  className?: string;
  id: string;
  size: 'sm' | 'md' | 'lg';
  value: string;
}

export const radioButtonSizeMap = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

const dotSizeMap = {
  sm: 'after:w-2 after:h-2',
  md: 'after:w-2.5 after:h-2.5',
  lg: 'after:w-3 after:h-3',
};

export const RadioButton: FC<RadioButtonProps> = ({
  value,
  className,
  size,
  id,
}) => {
  return (
    <RadioGroupPrimitive.Item
      className={cn(
        'cursor-pointer rounded-full border border-neutral-300 bg-neutral-0 hover:border-neutral-400 data-[state=checked]:border-prominence-500',
        radioButtonSizeMap[size],
        className,
      )}
      value={value}
      id={id}
    >
      <RadioGroupPrimitive.Indicator
        className={cn(
          "relative flex h-full w-full items-center justify-center after:block after:rounded-[50%] after:bg-prominence-500 after:content-['']",
          dotSizeMap[size],
        )}
      />
    </RadioGroupPrimitive.Item>
  );
};
